module.exports = __webpack_public_path__ + "img/plane.cf42c693.webp";